import type React from 'react';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';

import styles from './Logo.module.scss';

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = (props: LogoProps) => {
  return (
    <Link
      data-link="header-logo"
      data-company={company.name}
      to="/"
      className={styles.logoLink}
    >
      <img
        src={company.match({
          mcosmetic: company.images.logoColor?.light,
          default: company.images.logo.light,
        })}
        alt=""
        className={styles.logoImage}
      />
    </Link>
  );
};
